import { alphas } from './system/alphas';
import { palette } from './system/palette';

export const backgrounds = {
  background: 'white',
  'background.fade': alphas['darken-50'],
  'background.editorLoadingOverlay': alphas['darken-60'],
  'background.secondary': palette['gray-100'],
  'background.quiet': palette['gray-80'],
  'background.ai': 'rgba(243, 233, 251, 0.3)',
  'background.info': 'rgba(242, 242, 242, 0.5)',
  'background.gradient':
    'linear-gradient(136.25deg, #0053FF 9.28%, rgba(0, 83, 255, 0.2) 46.29%)',
};
